class DynamicProductCard extends HTMLElement {
  constructor() {
    super()
  }

  setVariables() {
    this.handle = this.getAttribute('handle')
    this.template = 'product-card-wide'
  }

  connectedCallback() {
    this.setVariables()
    if (!this.handle) return

    this.renderTemplate()
  }

  broadcastEvents() {
    const productsWrapper = this.closest('[dynamic-products-wrapper]')
    if (productsWrapper)
      productsWrapper.dispatchEvent(
        new CustomEvent('CARD_LOADED', {
          bubbles: true,
          composed: true
        })
      )
  }

  async renderTemplate() {
    const html = await this.getTemplate()
    this.innerHTML = html
    this.broadcastEvents()
  }

  async getTemplate() {
    try {
      const response = await fetch(
        `/products/${this.handle}?view=${this.template}`
      )
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }
      return await response.text()
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }
}

customElements.define('dynamic-product-card', DynamicProductCard)
